import { Injectable, inject, signal } from "@angular/core";
import { App } from "@capacitor/app";
import { ApplicationOverlayService } from "@services/application-overlay.service";
import mondaySdk from "monday-sdk-js";
import * as countryConfig from "src/app/modules/shared/config/countries-config.js";
import { environment } from "../../../../environments/environment.config";
import { mondayAppInfoQuery, mondayProjectsQuery } from "../constants/mondayquery.constants";
import { GlobalVarsModel } from "../models";
import { Utils } from "../utils/Utils";
import { NewBaseService } from "./newBase.service";

@Injectable({
  providedIn: "root",
})
export class MondayService {
  newBaseService = inject(NewBaseService);
  private mondayBoardId: number = environment.MONDAY_BOARD_ID;

  globalVars: GlobalVarsModel = this.newBaseService.globalsSignal();

  monday = mondaySdk({
    apiToken: environment.MONDAY_TOKEN,
  });

  mondayBoardInfo = signal<MondayBoardInfo>(null);
  mondayAppInfo = signal<MondayAppInfo>(null);

  utils = inject(Utils);
  applicationOverlayService = inject(ApplicationOverlayService);

  async getMondayProjects(): Promise<void> {
    try {
      const response = await this.monday.api(mondayProjectsQuery(this.mondayBoardId));
      this.mondayBoardInfo.set(response.data.boards[0].items_page);
    } catch (error) {
      throw new Error(error.message);
    }
  }

  async getMondayAppInfo(): Promise<void> {
    try {
      const response: { data: any; account_id: number } = await this.monday.api(
        mondayAppInfoQuery(this.utils.isAndroid()),
      );
      const data: MondayAppInfo = response.data.items[0].column_values.reduce((acc, e) => {
        return {
          ...acc,
          [e.id]: e.text,
        };
      });
      this.mondayAppInfo.set(data);
      this.validateAppUpdate();
    } catch (error) {
      throw new Error(error.message);
    }
  }

  private async validateAppUpdate() {
    const { version } = await App.getInfo();

    const isGreaterOrEqual = this.utils.isVersionGreaterOrEqualThan(
      version,
      this.mondayAppInfo()[MondayColumns.actualVersion],
    );
    if (isGreaterOrEqual) {
      return;
    }

    this.applicationOverlayService.setOverlayConfig({
      image: "assets/global/img/forced-update-image.svg",
      title: "forcedupdate",
      description: "forcedupdatedescription",
      buttonText: "Update",
      buttonAction: () => {
        window.open(this.getAppLink(), "_blank");
      },
      canBeClosed: false,
    });
  }

  private getAppLink(): string {
    const country = this.utils.LicenseTypeNameNative(this.globalVars.licenseType);
    const config = countryConfig[country];

    return this.utils.isAndroid() ? config.appLinkAndroid : config.appLinkiOS;
  }
}

async function updateAppVersion(): Promise<void> {
  //TODO:
}

async function updateWebVersion(): Promise<void> {
  //TODO:
}

export interface MondayBoardInfo {
  id: string;
  name: string;
}

export interface MondayAppInfo {
  color_mknrmet3: string;
  country_mknrvfdw: string;
  dropdown_mknr4yex: string;
  dropdown_mkrarc7k: string;
  date4: string;
  status: string;
  subtasks_mknr76nm: string;
  link_mknr21n6: string;
  dropdown_mknr7amx: string;
  text_mknrksga: string;
  date_mknx1h2v: string;
}

export enum MondayColumns {
  device = "color_mknrmet3",
  country = "country_mknrvfdw",
  actualVersion = "dropdown_mknr4yex",
  webVersion = "dropdown_mkrarc7k",
  lastUpdate = "date4",
  status = "status",
  subitems = "subtasks_mknr76nm",
  link = "link_mknr21n6",
  release = "dropdown_mknr7amx",
  notes = "text_mknrksga",
  nextUpdate = "date_mknx1h2v",
}
